import { useEffect, useRef, useState } from "react";

import { useData } from "data/data-provider";
import SectionGridAllFleet from "./SectionGridAllFleet";
import { useLocation, useNavigate } from "react-router-dom";
import RentalPolicies from "designs/DesignB/components/RentalPolicies/RentalPolicies";
import SectionTestimonials from "designs/DesignA/components/SectionTestimonials/SectionTestimonials";
import WhyChooseUS from "designs/DesignA/components/WhyChooseUS/WhyChooseUs";
import SectionAbout from "../PageAbout/SectionAbout";
import SectionHero from "designs/DesignA/components/SectionHero/SectionHero";
import GlobalPopUp from "shared/pop-up/global_popUp";

function PageHome() {
  const { aboutUs, whyUs, testimonials, faqs, ourVehicles, popUp } = useData();
  const location = useLocation();
  const navigate = useNavigate();
  const hasScrolled = useRef(false);
  const [showPopUp, setShowPopUp] = useState(false);

  useEffect(() => {
    localStorage.removeItem("access_token");
    localStorage.removeItem("refresh_token");
    localStorage.removeItem("user");
  }, []);

  useEffect(() => {
    const hash = location.hash;

    if (
      hash &&
      hash.length > 1 &&
      !location.pathname.includes("loading") &&
      !hasScrolled.current
    ) {
      setTimeout(() => {
        const element = document.querySelector(hash);
        if (element) {
          element.scrollIntoView({ behavior: "smooth" });
          setTimeout(() => {
            navigate(location.pathname, { replace: true });
            hasScrolled.current = true;
          }, 1000);
        }
      }, 500);
    }
    if (!hash) {
      hasScrolled.current = false;
    }
  }, [
    location.hash,
    location.pathname,
    navigate,
    aboutUs,
    whyUs,
    testimonials,
    faqs,
    ourVehicles,
  ]);

  useEffect(() => {
    if (popUp && popUp?.heading && popUp?.description) {
      const hasShown = sessionStorage.getItem("hasShownWelcomePopup");
      if (!hasShown) {
        setShowPopUp(true);
        sessionStorage.setItem("hasShownWelcomePopup", "true");
      }
    }
  }, [popUp]);

  const handleClosePopUp = () => {
    setShowPopUp(false);
    sessionStorage.setItem("hasShownWelcomePopup", "true");
  };

  return (
    <>
      <div className="relative">
        <SectionHero />
        <div className="container relative" style={{ padding: "0px" }}>
          <div>

            <div
              className="container relative mt-16 sm:px-0"
              id="section-all-fleet"
            >
              <SectionGridAllFleet />
            </div>

            {aboutUs && (
              <div className="container mt-16 sm:px-0" id="section-about-us">
                <SectionAbout aboutUs={aboutUs} />
              </div>
            )}
            {(whyUs?.heading ||
              whyUs?.description ||
              whyUs?.image_url ||
              whyUs?.keypoints?.length > 0) && (
                <div
                  className="container mt-16 sm:px-0"
                  id="section-why-choose-us"
                >
                  <WhyChooseUS />
                </div>
              )}
            {(testimonials?.heading || testimonials?.keypoints?.length > 0) && (
              <div
                className="container mt-16 sm:px-0"
                id="section-testimonials"
              >
                <SectionTestimonials uniqueClassName="PageAbout_" />
              </div>
            )}
          </div>
        </div>
        {(faqs?.heading ||
          faqs?.description ||
          faqs?.keypoints?.length > 0) && (
            <div className="container relative py-16" id="section-faqs">
              <RentalPolicies />
            </div>
          )}
        {popUp && popUp?.heading && popUp?.description && (
          <GlobalPopUp
            onClose={() => { handleClosePopUp() }}
            isShowModal={showPopUp}
            popUpData={popUp}
          />
        )}
      </div>
    </>
  );
}

export default PageHome;
